// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2gLOW","col":"styles_col__3xj1s"};